module.exports = __webpack_public_path__ + "static/media/notFoundIllustration.9a29d695.svg";